import { Reducer } from "redux";

import { BenefitPlanUidResponse } from "../models/api/Patient";
import { BenefitPlanUidActionDispatchTypes } from "../constants/Patient";
import { BenefitPlanUidDispatchTypes } from "../models/dispatchTypes/Patient";

const initialState: BenefitPlanUidResponse = {
  loading: false,
  response: {
    healthPlanId: 0,
    benefitPlanId: 0,
    healthPlan: "",
    product: "",
    benefitPlanNm: "",
    benefitPlanName: "",
    benefitPlanUid: "",
    healthPlanState: "",
    lengthOfEpisode: 0
  },
  error: null,
};

const BenefitPlanUidReducer: Reducer<BenefitPlanUidResponse, BenefitPlanUidDispatchTypes> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case BenefitPlanUidActionDispatchTypes.BENEFIT_PLAN_UID_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case BenefitPlanUidActionDispatchTypes.BENEFIT_PLAN_UID_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
    case BenefitPlanUidActionDispatchTypes.BENEFIT_PLAN_UID_ERRORS: {
      return initialState;
    }
    case BenefitPlanUidActionDispatchTypes.BENEFIT_PLAN_UID_RESET: {
      return initialState;
    }
  }
  return state;
};

export default BenefitPlanUidReducer;
